import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { RouterProvider } from "react-router-dom";
import { reactQueryClient } from '~/shared/contexts/CommonAppContext';
import router from '../routes/benlieb-app-routes';

declare global {
  interface Window {
    benlieb_app: {
      config: {
        site_id: number,
        server_env: {
          stripe_mode: 'live' | 'test',
        }
      },
      constants: {
        images: {
          thumbnails: string[]
        }
      }
    }
  }
}

const BenliebApp = () => {
  return (
    <QueryClientProvider client={reactQueryClient} >
      <RouterProvider router={router} />

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default BenliebApp;